
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselGenericStoppedOutlined as ObiVesselGenericStoppedOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-generic-stopped-outlined.js';
 
 
 

 
 export const ObiVesselGenericStoppedOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-generic-stopped-outlined',
   elementClass: ObiVesselGenericStoppedOutlinedElement,
   events: {
     
   }
  });
 
 